import React from 'react';
import Radio from './Radio';

export default function Radios({
  data,
  onCheck,
  children,
  className = '',
  bg = 'bg-white80',
  innerBg = 'bg-white',
  padding = 'px-6',
  innerPadding = 'py-4',
  leftNegativePosition = '-left-6',
  radioValue,
  flexDirection,
  radioClassName,
  outerRadioClassName,
}) {
  return (
    <div
      className={`flex flex-col ${padding} ${bg}  relative ${leftNegativePosition} lookup-filter ${className}`}
    >
      <div
        className={` ${innerBg} relative flex items-start w-full ${
          flexDirection ? flexDirection : 'flex-col'
        } ${innerPadding}  animate-dropdown`}
      >
        {data?.map(({value, label, name, price}, index) => (
          <Radio
            key={value + index}
            handleChecked={onCheck}
            label={label}
            value={value}
            name={name}
            checked={radioValue === value}
            otherText={price}
            className={radioClassName}
            outerRadioClassName={outerRadioClassName}
          />
        ))}
        {children}
      </div>
    </div>
  );
}
